import React from "react"
import PropTypes from "prop-types"
import FolioImage from "../../images/folio/1.jpg"
import { Link } from "gatsby"
const gallery = () => {
  return (
    <div className="single-slider-wrap slider-carousel-wrap ">
      <div className="single-slider cur_carousel-slider-container fl-wrap">
        <div className="slick-slide-item">
          <img src={FolioImage} alt="Slide Image" />
        </div>
        <div className="slick-slide-item">
          <img src={FolioImage} alt="Slide Image" />
        </div>
        <div className="slick-slide-item">
          <img src={FolioImage} alt="Slide Image" />
        </div>
      </div>
      <div className="sp-cont   sp-cont-prev">
        <i className="fal fa-long-arrow-left"></i>
      </div>
      <div className="sp-cont   sp-cont-next">
        <i className="fal fa-long-arrow-right"></i>
      </div>
    </div>
  )
}

const image = (image, text) => {
  return (
    <div className="blog-media fl-wrap">
      <img src={image.childImageSharp.fluid.src} alt={text} />
    </div>
  )
}
const BlogMeta = ({ frontmatter, fields, excerpt }) => {
  return (
    <div className="post fl-wrap fw-post">
      <h2>
        <Link to={fields.slug}>
          <span>{frontmatter.title}</span>
        </Link>
      </h2>

      <div className="parallax-header">
        <Link to="#">{frontmatter.date}</Link>
        <span>Category : </span>
        <Link to={`/category/${fields.category}`}>{frontmatter.category}</Link>
      </div>

      {frontmatter && frontmatter.featuredImage ? (
        <div className="blog-media fl-wrap nomar-bottom">
          <Link to={fields.slug}>
            {image(frontmatter.featuredImage, frontmatter.title)}{" "}
          </Link>
        </div>
      ) : (
        ""
      )}

      {fields.tags ? (
        <div className="parallax-header fl-wrap">
          <span>Tags : </span>
          {fields.tags.map((tag, idx) => (
            <Link key={idx} to={`/tags/${tag}`}>
              {tag}
            </Link>
          ))}
        </div>
      ) : null}

      <div className="blog-text fl-wrap">
        <div className="clearfix"></div>
        <h3>{frontmatter.subtitle}</h3>
        <div
          dangerouslySetInnerHTML={{
            __html: excerpt,
          }}
        />
      </div>
    </div>
  )
}

export default BlogMeta
